import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AppService } from '../../app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { qmsSettingsInterface } from './qmsSettingsObj'
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { StaticAuditTrailComponent } from '../../support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from '../../support/excel-pdf/excel-pdf.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-qms-settings-vw',
  templateUrl: './qms-settings-vw.component.html',
  styleUrls: ['./qms-settings-vw.component.scss']
})

export class QmsSettingsVwComponent implements OnInit {

  isProcessing = true;
  isQmsSettingsDataEmpty = false;
  qmsSettingsList: qmsSettingsInterface[] = [];
  popupDataTitle: PopupData = {
    title: ''
  };

  @Input() qmsSettingsObj: any = {};

  dropDownForReportTimezone: any = [];
  selectedTimeZone: any = null;
  timeZoneListDropdown: any = [];
  primarySelectorList: any = [
    {
      valueExp: "Group",
      displayExp: "Group"
    },
    {
      valueExp: "Module",
      displayExp: "Module"
    },
  ];
  organizationPrivelegesDetails: any = [];
  dropDownForIncidentGroup: any = [];
  selectedIncidentGroup: any = null;
  incidentGroupDropdown: any = [];
  oddTimezone: any = null;
  oddIncidentGroup: any = null;
  selectPrimarySelectorAtUIPage: any;
  moduletabList: any = [];
  moduleList: any = [];
  ngOnInit() {
    this.isProcessing = true;
    this.moduletabList = ["Preliminary Actions", "Analytical", "Microbiology", "Phase II", "Phase III", "Data Evaluation", "Batch Disposition & Closure", "Actions", "Parallel Workflow", "Investigation", "Files", "Reviewer/Approver", "Effectiveness Check", "Extension"
      , "Dependency", "Risk Assessment", "Notifications", "History", "Products", "Final Evaluation", "Reimbursement", "Response",
      "Questionnaire", "Participants", "Findings", "Followups", "Recommendations"
    ];
    this.dropDownForReportTimezone = JSON.parse(sessionStorage.getItem('dropDownForReportTimezone') ?? '{}');
    this.selectBoxForTimeZone();
    this.appService.getQmsGroupsByModule("IN").subscribe((data: any) => {
      this.dropDownForIncidentGroup = data;
      this.selectBoxForGroupValue();
      this.appService.getQmsSettingVw().subscribe({
        next: (data: any) => {
          if (data == null) {
            this.qmsSettingsList = data;
            this.qmsSettingsObj = {};
            this.selectedTimeZone = null;
            this.isQmsSettingsDataEmpty = true;
            this.isProcessing = false;
          } else {
            if (data.reportsTimezone) {
              const matchingTimeZone = this.dropDownForReportTimezone?.find((item: any) => item.codelistCode == data.reportsTimezone);
              if (!matchingTimeZone) {
                this.oddTimezone = data.reportsTimezone;
                this.timeZoneListDropdown.push({
                  valueExp: data.reportsTimezone,
                  displayExp: data.reportsTimezone
                })
              }
              this.selectedTimeZone = data.reportsTimezone;
            }
            if (data.defaultIncidentGroupId) {
              const matchingIncidentGroupId = this.dropDownForIncidentGroup?.find((item: any) => item.groupId == data.defaultIncidentGroupId);
              if (!matchingIncidentGroupId) {
                this.oddIncidentGroup = data.defaultIncidentGroupId;
                this.incidentGroupDropdown.push({
                  valueExp: data.defaultIncidentGroupId,
                  displayExp: data.defaultIncidentGroupId
                })
              }
              this.selectedIncidentGroup = data.defaultIncidentGroupId;
            }


            this.selectPrimarySelectorAtUIPage = data.primarySelectorAtUIPage;


            this.qmsSettingsList = data;
            this.qmsSettingsObj = this.qmsSettingsList;
            this.qmsSettingsObj.selectedAllowedFileExtns = this.qmsSettingsObj.allowedFileExtns.split(",");

            this.isQmsSettingsDataEmpty = false;
            this.isProcessing = false;
          }
        }, error: (error) => {
          this.isProcessing = false;
        }
      })
    })

    this.isProcessing = true;
    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.organizationDetails = data;
      this.allowedFileExtnListMethod();
    });

    this.appService.getOneQmsOrganizationPrivileges().subscribe((data: any) => {
      data.cr = data.cr == "Y";
      data.capa = data.capa == "Y";
      data.dv = data.dv == "Y";
      data.au = data.au == "Y";
      data.in = data.in == "Y";
      data.qi = data.qi == "Y";
      data.cc = data.cc == "Y";
      data.trn = data.trn == "Y";
      data.docs = data.docs == "Y";
      data.oos = data.oos == "Y";
      this.organizationPrivelegesDetails = data;
      this.isProcessing = false;
    })


    this.appService.getCodeListsByGroup("MODULES")
      .subscribe((response: any) => {
        this.moduleList = response;
        this.getModuleName();
        // handle response as needed
      });
  }
  editorTitleMapping: Record<string, any>

  getModuleName() {
    this.editorTitleMapping = {
      'CR': this.moduleList.find((name: any) => name.codelistCode == "CR")?.codelistName,
      'CC': this.moduleList.find((name: any) => name.codelistCode == "CC")?.codelistName,
      'CAPA': this.moduleList.find((name: any) => name.codelistCode == "CAPA")?.codelistName,
      'AU': this.moduleList.find((name: any) => name.codelistCode == "AU")?.codelistName,
      'QI': this.moduleList.find((name: any) => name.codelistCode == "QI")?.codelistName,
      'IN': this.moduleList.find((name: any) => name.codelistCode == "IN")?.codelistName,
      'OOS': this.moduleList.find((name: any) => name.codelistCode == "OOS")?.codelistName,
      'DV': this.moduleList.find((name: any) => name.codelistCode == "DV")?.codelistName,
    };

  }

  organizationDetails: any;
  allowedFileExtnList: any;
  allowedFileExtnListMethod() {
    let list = this.organizationDetails.allowedFileExtns.split(",");
    this.allowedFileExtnList = list.map((e: any) => ({
      valueExp: e,
      displayExp: e
    }));
  };
  refreshForm() {
    this.ngOnInit();
  }
  allowedFileExtnsSearchText: any = "";
  allSelected = false;
  allCoreBusinessSelected = false;
  @ViewChild('reasonForChange') reasonForChange: MatSelect;
  toggleAllSelection(value: any) {
    if (value == 'reasonForChange') {
      if (this.allSelected) {
        this.reasonForChange.options.forEach((item: MatOption) => item.select());
      } else {
        this.reasonForChange.options.forEach((item: MatOption) => item.deselect());
      }
    }

  }
  constructor(public appService: AppService, public dialog: MatDialog, private readonly snackBar: MatSnackBar, public message: messageService,) { }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }
  focusEmpty() {
    console.log();
  }
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }


  selectBoxForTimeZone() {
    this.timeZoneListDropdown = [];
    this.timeZoneListDropdown = this.dropDownForReportTimezone.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))
  }

  reportsTimezonesearchTxt: any;
  primarySelectorSearchTxt: any;
  onReportsTimezoneSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedTimeZone = item.valueExp;
      } else {
        this.selectedTimeZone = undefined;
      }
    }
  }
  selectBoxForGroupValue() {
    this.incidentGroupDropdown = [];
    this.incidentGroupDropdown = this.dropDownForIncidentGroup.map((item: any) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    }))
  }

  incidentGroupsearchTxt: any;

  onIncidentGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedIncidentGroup = item.valueExp;
        this.isProcessing = true;
        this.appService.getQmsGroupDetailsByModule(item.valueExp, 'IN').subscribe((data: any) => {
          this.isProcessing = false;
          if (!data) {
            this.showSnackBar("Incident Module have not added in this group " + item.displayExp + " Please contact Administrator", 'E');
            this.selectedIncidentGroup = null;
          }
        })
      } else {
        this.selectedIncidentGroup = undefined;
      }
    }
  }
  snackbarRef: any;

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  saveQmsSettings(qmsSettingsObj: any) {
    if (this.isQmsSettingsDataEmpty) {
      this.isProcessing = true;
      qmsSettingsObj.defaultIncidentGroupId = this.selectedIncidentGroup ? this.selectedIncidentGroup : null;
      qmsSettingsObj.allowedFileExtns = this.qmsSettingsObj.selectedAllowedFileExtns.join(",");
      if (this.selectedTimeZone) {
        qmsSettingsObj.reportsTimezone = this.selectedTimeZone;
      } else {
        qmsSettingsObj.reportsTimezone = null;
      }

      if (this.selectPrimarySelectorAtUIPage) {
        qmsSettingsObj.primarySelectorAtUIPage = this.selectPrimarySelectorAtUIPage;
      }
      this.appService.createQmsSettings(qmsSettingsObj).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == "S") {
            this.ngOnInit();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      })
    } else {
      delete qmsSettingsObj['createdOn'];
      delete qmsSettingsObj['updatedOn'];
      this.isProcessing = true;
      qmsSettingsObj.allowedFileExtns = this.qmsSettingsObj.selectedAllowedFileExtns.join(",");
      qmsSettingsObj.defaultIncidentGroupId = this.selectedIncidentGroup ? this.selectedIncidentGroup : null;
      if (this.selectedTimeZone) {
        qmsSettingsObj.reportsTimezone = this.selectedTimeZone;
      } else {
        qmsSettingsObj.reportsTimezone = null;
      }
      if (this.selectPrimarySelectorAtUIPage) {
        qmsSettingsObj.primarySelectorAtUIPage = this.selectPrimarySelectorAtUIPage;
      }
      this.appService.updateQmsSettings(qmsSettingsObj).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == "S") {
            this.ngOnInit();
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = false;
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail() {
    this.message.tableOrView_Name = "QMS_SETTINGS_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,CR_ID_REGENERATION,CR_ID_NO_OF_DIGITS,CR_ID_FORMAT,CAPA_ID_REGENERATION,CAPA_ID_NO_OF_DIGITS,CAPA_ID_FORMAT,DV_ID_REGENERATION,DV_ID_NO_OF_DIGITS,DV_ID_FORMAT,AU_ID_REGENERATION,AU_ID_NO_OF_DIGITS,AU_ID_FORMAT,IN_ID_REGENERATION,IN_ID_NO_OF_DIGITS,IN_ID_FORMAT,DEFAULT_INCIDENT_GROUP_NAME,QI_ID_REGENERATION,QI_ID_NO_OF_DIGITS,QI_ID_FORMAT,CC_ID_REGENERATION,CC_ID_NO_OF_DIGITS,CC_ID_FORMAT,INTIMATE_AUDIT_SCHEDULE_BEFORE_N_DAYS,REPORTS_TIMEZONE,RISK_FORMULA,PDF_FOOTER_CONTENT,ALLOWED_FILE_EXTNS,PRIMARY_SELECTOR_AT_UI_PAGE,TAB_PAGES_ORDER,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,CR ID Regeneration,CR ID No of Digits,CR ID Format,CAPA ID Regeneration,CAPA ID No of Digits,CAPA ID Format,DV ID Regeneration,DV ID No of Digits,DV ID Format,AU ID Regeneration,AU ID No of Digits,AU ID Format,IN ID Regeneration,IN ID No of Digits,IN ID Format,Incident Group,QI ID Regeneration,QI ID No of Digits,QI ID Format,CC ID Regeneration,CC ID No of Digits,CC ID Format,Inimate Audit Schedule Before N Days,Reports Timezone,Risk Formula,PDF Footer Content,Allowed File Extns,Primary Selector,Module Tab Order,Created On,Created By User,Updated On,Updated By User,Update Reason";
    this.message.whereClause_AU = "";
    this.message.columnList_Report = this.message.columnList_UI;
    this.message.whereClause_Report = "";
    this.message.report_And_Popup_Name = "Quality Settings Audit Trail";
    this.staticAuditTrailComponent.triggerTrail(0);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "QMS_SETTINGS_VW";
    this.excelPdf.columnList_DB = "CR_ID_FORMAT,CR_ID_NO_OF_DIGITS,CR_ID_REGENERATION,CAPA_ID_FORMAT,CAPA_ID_NO_OF_DIGITS,CAPA_ID_REGENERATION,DV_ID_FORMAT,DV_ID_NO_OF_DIGITS,DV_ID_REGENERATION,AU_ID_FORMAT,AU_ID_NO_OF_DIGITS,AU_ID_REGENERATION,IN_ID_FORMAT,IN_ID_NO_OF_DIGITS,IN_ID_REGENERATION,DEFAULT_INCIDENT_GROUP_NAME,QI_ID_FORMAT,QI_ID_NO_OF_DIGITS,QI_ID_REGENERATION,CC_ID_FORMAT,CC_ID_NO_OF_DIGITS,CC_ID_REGENERATION,INTIMATE_AUDIT_SCHEDULE_BEFORE_N_DAYS,REPORTS_TIMEZONE,RISK_FORMULA,PDF_FOOTER_CONTENT,ALLOWED_FILE_EXTNS,PRIMARY_SELECTOR_AT_UI_PAGE,TAB_PAGES_ORDER,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON,UPDATE_REASON";
    this.excelPdf.columnList_Report = "CR Id Format,CR Id No of Digits,CR Id Regeneration,CAPA Id Format,CAPA Id No of Digits,CAPA Id Regeneration,DV Id Format,DV Id No of Digits,DV Id Regeneration,AU Id Format,AU Id No of Digits,AU Id Regeneration,In Id Format,In Id No of Digits,In Id Regeneration,Default Incident Group Name,QI Id Format,QI Id No of Digits,QI Id Regeneration,CC Id Format,CC Id No of Digits,CC Id Regeneration,Intimate Audit Schedule Before N Days,Reports Timezone,Risk Formula,PDF Footer Content,Allowed File Extensions,Primary Selector,Module Tab Order,Create By User,Create On,Update By User,Update On,Update Reason";
    this.excelPdf.whereClause_Report = '';
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Quality Settings Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }


  //reorder
  @ViewChild('reorderPopup', { static: true }) reorderPopup: TemplateRef<any>;
  visiblereorderPopup: MatDialogRef<TemplateRef<any>>;
  contentList: any;
  reorderPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };
  openreorder() {
    this.contentList = [];

    if (this.qmsSettingsObj.tabPagesOrder == null) {
      for (let j = 0; j < this.moduletabList.length; j++) {
        this.contentList.push({
          fieldName: this.moduletabList[j],
          currentSeq: j + 1,
          newSeq: j + 1
        })
      }
    } else {
      let data1 = this.qmsSettingsObj.tabPagesOrder?.split(",")
      for (let j = 0; j < data1.length; j++) {
        this.contentList.push({
          fieldName: data1[j],
          currentSeq: j + 1,
          newSeq: j + 1
        })
      }
    }


    this.isProcessing = false;
    this.visiblereorderPopup = this.dialog.open(this.reorderPopup, this.reorderPopupConfig);
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.contentList, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.contentList.length; i++) {
      this.contentList[i].newSeq = i + 1;
    }
  };

  @ViewChild('resetOrderPopup', { static: true }) resetOrderPopup: TemplateRef<any>;
  visibleresetOrderPopup: MatDialogRef<TemplateRef<any>>;
  //contentList:any;
  resetOrderPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };
  resetFunction() {
    this.visibleresetOrderPopup = this.dialog.open(this.resetOrderPopup, this.resetOrderPopupConfig);
  }
  resetList() {
    this.contentList = [];
    for (let j = 0; j < this.moduletabList.length; j++) {
      this.contentList.push({
        fieldName: this.moduletabList[j],
        currentSeq: j + 1,
        newSeq: j + 1
      })
    };
    this.visibleresetOrderPopup.close();
  }
  cancelResetList() {
    this.visibleresetOrderPopup.close();
  }
  reorderContentFunction() {
    let data = [];

    for (const item of this.contentList) {
      data.push(item.fieldName);
    }
    this.qmsSettingsObj.tabPagesOrder = data.toString();
    this.saveQmsSettings(this.qmsSettingsObj);
    this.cancelReorderFunction();
  };
  cancelReorderFunction() {
    this.visiblereorderPopup.close();
  };
}
